import { Component, Fragment } from 'react';

class DownloadLinks extends Component {
  render () {
    return  <Fragment>
              {
                  !this.props.imported_xml && <li className="text-sm hover:bg-gray-200">
                        <a href={'download-cd/' + this.props.search_id + '.json'}>
                            <div className='relative flex flex-col items-center group'>
                                <div className='flex items-center w-full'>
                                    <span className='w-full text-sm text-seqblue hover:text-seqorange download cursor-pointer py-0.5 px-0.5'>Conserved Domains hits JSON</span>
                                    <div className="absolute hidden left-full ml-2 items-center  group-hover:flex w-[300px]">
                                        <div className="w-0 h-0 border-t-[8px] border-b-[7px] border-r-[7px] border-t-transparent border-b-transparent border-r-black -mr-[1px]"></div>
                                        <span className='relative z-10 p-2 text-xs leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-[5px]'>
                                            Conserved Domains Results in JSON format.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                        
                  </li>
              }
            </Fragment>
  }
}

export default DownloadLinks;
